<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col></b-col>
            <b-col class="text-center title">點數兌換券上架 / 商品券贈送</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1 >查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-card class='bg-warning-card'>
                <div class="row">
                    <b-modal size='lg' ref='editTicket' hide-footer title='商品券贈送明細'>
                        <b-container fluid>
                            <form>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>贈券活動ID：</label>
                                    <div class='col-md-7'>
                                        {{editId}}
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                <label class='control-label col-md-3'>是否發推播：</label>
                                    <div class='col-md-9'>
                                        <toggle-button disabled="true" v-model="editToSendMessage" :sync="true" :height=30 :width=60
                                        style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}"/>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>推播顯示文字：</label>
                                    <div class='col-md-7'>
                                        {{editName}}
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>贈卷型態：</label>
                                    <div class='col-md-7'>
                                        {{editGiveTypeName}}
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>贈送票券：</label>
                                    <div class='col-md-7'>
                                        {{editTicketCode}} {{editTicketName}}
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editGiveType ==1">
                                    <label class='control-label col-md-3'>受贈會員入會區間：</label>
                                    <div class='col-md-7'>
                                        {{editSaleDay_S}}~{{editSaleDay_E}}
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editGiveType ==2">
                                    <label class='control-label col-md-3'>受贈會員生日月份區間：</label>
                                    <div class='col-md-7'>
                                        {{editSaleDay_S}}~{{editSaleDay_E}}
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editGiveType ==4">
                                    <label class='control-label col-md-3'>會員手機號碼：</label>
                                    <div class='col-md-7'>
                                        {{editMobile}}
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editGiveType ==5">
                                    <label class='control-label col-md-3'>匯入檔案的會員數量：</label>
                                    <div class='col-md-7'>
                                        {{memberAmount}}
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editGiveType == 3 || editGiveType== 4 || editGiveType == 5">
                                    <label class='control-label col-md-3'>預約贈送日：</label>
                                    <div class='col-md-7'>
                                        {{editSaleDay_E}}
                                    </div>
                                </div>
                                <!-- <div class='row mb-3'>
                                    <label class='control-label col-md-3'>是否已贈送：</label>
                                    <div class='col-md-7'>
                                        {{(editIsSend === true) ? '是' : '否'}}
                                    </div>
                                </div> -->
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>已贈送票卷的總量：</label>
                                    <div class='col-md-7'>
                                        {{editAmount}}
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>異動人員：</label>
                                    <div class='col-md-7'>
                                         {{ editGiveType !== 6 ? editUpdId : editStoreName + '門市' }}
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>異動時間：</label>
                                    <div class='col-md-7'>
                                        {{editUpdTime}}
                                    </div>
                                </div>
                                <div class='float-right'>
                                    <b-btn variant='primary' @click='editCancel'>關閉</b-btn>
                                </div>
                            </form>
                        </b-container>
                    </b-modal>
                    <div class='col-lg-12'>
                        <b-tabs card class="tab_color">
                            <b-tab title='即將進行/進行中活動' @click="changeTab(1)" :active='this.modelTab == 1'>
                                <div class='row mt-3'></div>
                                <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                                    <b-card class='bg-default-card'>
                                        <div class='row'>
                                            <div class='col-lg-12'>
                                                <div class='p-4 box-shadow' header='Form Elements'>
                                                    <div class='row'>
                                                        <label class='control-label col-md-3'>贈卷型態：</label>
                                                        <div class='col-md-5'>
                                                            <select id='queryGiveType1' name='queryGiveType1' class='form-control' v-model='queryTab1.queryGiveType1'>
                                                                <option value=0>全部</option>
                                                                <option value='1'>新加入會員</option>
                                                                <option value='2'>生日禮</option>
                                                                <option value='3'>所有正式會員</option>
                                                                <option value='4'>單一會員</option>
                                                                <option value='5'>會員資料匯入</option>
                                                                <option value="6">店長系統</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-3'>推播顯示文字：</label>
                                                        <div class='col-md-5'>
                                                            <input type='text' class='form-control' placeholder='請輸入推播顯示文字 (模糊查詢)' v-model='queryTab1.queryTciketName1'>
                                                        </div>
                                                        <div class='col-md-4'>
                                                            <button type='button' class='btn btn-warning text-white ' @click="search(1)">查詢</button>
                                                            <button type='reset' class='btn btn-warning text-white' @click.prevent="resetForm1">重設</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                                <div>
                                    <div class='row'>
                                        <div class='col-lg-12 mb-3'>
                                            <div class='table-responsive'>
                                                <div class="text-right">
                                                    <router-link v-show='FunctionPermission > 1' :to="{ name: 'coupon_give_add', params: { queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse}  }" class='btn btn-outline-light'>新增贈券</router-link>
                                                </div>
                                                <table id='mytable' class='table table-bordred table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>項次</th>
                                                            <th>推播</th>
                                                            <th>推播顯示文字</th>
                                                            <th>贈卷型態</th>
                                                            <th>券名稱</th>
                                                            <th>贈送期間</th>
                                                            <!-- <th>是否已贈</th> -->
                                                            <th>已贈總量</th>
                                                            <th>異動人</th>
                                                            <th>異動時間</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for='(x, index) in listTicket1' :key="x.id">
                                                            <td>{{((queryTab1.currentPage-1)*pageRows+index+1)}}</td>
                                                            <td>{{(x.toSendMessage===true) ? 'V': ''}}</td>
                                                            <td>{{x.name}}</td>
                                                            <td>{{x.giveTypeName}}</td>
                                                            <td>{{x.giftCertificateName}}</td>
                                                            <td>{{x.applicableStartAt}}<br>{{x.applicableEndAt}}</td>
                                                            <!-- <td>{{(x.isSend === true) ? '是' : '否'}}</td> -->
                                                            <td>{{x.amount}}</td>
                                                            <td>{{ x.giveType === 6 ? x.storeName + '門市' : x.updatedName}}</td>
                                                            <td>{{x.updatedAt}}</td>
                                                            <td>
                                                                <router-link :to="{ name: 'coupon_give_edit', params: { item: x, queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse } }" class="btn-circle btn-circle-ptc1" v-show='FunctionPermission > 1 && x.giveType!==4 && x.giveType!==6' tag="button"><i class="fas fa-pencil-alt" title="編輯"></i></router-link> <!-- 分頁處理 -->
                                                                <button class='btn-circle btn-circle-ptc1' @click='editTicket(x, 1)'><span class='fa fa-search-plus'></span></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="row" style="padding: 0 1rem">
                                                <b-pagination size="md" :total-rows="queryTab1.totalRows" v-model="queryTab1.currentPage" :per-page="pageRows" @change="search"></b-pagination>
                                                <label style="margin:8px">{{queryTab1.startRowNum}}到{{queryTab1.endRowNum}}，總共 {{queryTab1.totalRows}}筆</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title='過期活動' @click="changeTab(2)" :active='this.modelTab == 2'>
                                <div class='row mt-3'></div>
                                <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                                            <b-card class='bg-default-card'>
                                                <div class='row'>
                                                    <div class='col-lg-12'>
                                                        <div class='p-4 box-shadow' header='Form Elements'>
                                                            <div class='row'>
                                                                <label class='control-label col-md-3'>贈卷型態：</label>
                                                                <div class='col-md-5'>
                                                                    <select id='queryGiveType2' name='queryGiveType2' class='form-control' v-model='queryTab2.queryGiveType2'>
                                                                        <option value='0'>全部</option>
                                                                        <option value='1'>新加入會員</option>
                                                                        <option value='2'>生日禮</option>
                                                                        <option value='3'>所有正式會員</option>
                                                                        <option value='4'>單一會員</option>
                                                                        <option value='5'>會員資料匯入</option>
                                                                        <option value='6'>店長系統</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class='row mt-3'>
                                                                <label class='control-label col-md-3'>推播顯示文字：</label>
                                                                <div class='col-md-5'>
                                                                    <input type='text' class='form-control' placeholder='請輸入推播顯示文字 (模糊查詢)' v-model='queryTab2.queryTciketName2'>
                                                                </div>
                                                                <div class='col-md-4'>
                                                                    <button type='button' class='btn btn-warning text-white ' @click="search(1)">查詢</button>
                                                                    <button type='reset' class='btn btn-warning text-white' @click.prevent="resetForm2">重設</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card>
                                </b-collapse>
                                <div>
                                    <div class='row'>
                                        <div class='col-lg-12 mb-3'>
                                            <div class='table-responsive'>
                                                <table id='mytable' class='table table-bordred table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>項次</th>
                                                            <th>推播</th>
                                                            <th>推播顯示文字</th>
                                                            <th>贈卷型態</th>
                                                            <th>券名稱</th>
                                                            <th>贈送期間</th>
                                                            <th>是否已贈</th>
                                                            <th>已贈總量</th>
                                                            <th>異動人</th>
                                                            <th>異動時間</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for='(x, index) in listTicket2' :key="x.id">
                                                            <td>{{((queryTab2.currentPage-1)*pageRows+index+1)}}</td>
                                                            <td>{{(x.toSendMessage===true) ? 'V': ''}}</td>
                                                            <td>{{x.name}}</td>
                                                            <td>{{x.giveTypeName}}</td>
                                                            <td>{{x.giftCertificateName}}</td>
                                                            <td>{{x.applicableStartAt}}<br>{{x.applicableEndAt}}</td>
                                                            <td>{{(x.isSend === true) ? '是' : '否'}}</td>
                                                            <td>{{x.amount}}</td>
                                                            <td>{{ x.giveType === 6 ? x.storeName + '門市' : x.updatedName}}</td>
                                                            <td>{{x.updatedAt}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="row" style="padding: 0 1rem">
                                                <b-pagination size="md" :total-rows="queryTab2.totalRows" v-model="queryTab2.currentPage" :per-page="pageRows" @change="search"></b-pagination>
                                                <label style="margin:8px">{{queryTab2.startRowNum}}到{{queryTab2.endRowNum}}，總共 {{queryTab2.totalRows}}筆</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script src='//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js'></script>
<script src='//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js'></script>
<script src='//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js'></script>
<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

import axios from 'axios'
import { API_URL } from '@/store/root.js'
import miniToastr from 'mini-toastr'
import ToggleButton from 'vue-js-toggle-button'
miniToastr.init()
Vue.use(ToggleButton)

// 功能權限function
import {getFunctionPermission} from '@/js/LoginUserFunction.js'

export default {
    data () {
        return {
            modelTab: 1,
            collapse: false,
            tab: 1,
            queryTab1: {
                queryGiveType1: 0, // 查詢條件:贈券型態
                queryTciketName1: "", // 查詢條件:贈券活動名稱
                currentPage: 1, // 目前頁碼
                totalRows: 0, // 總筆數
                startRowNum: 0,
                endRowNum: 0
            },
            queryTab2: {
                queryGiveType2: 0, // 查詢條件:贈券型態
                queryTciketName2: '', // 查詢條件:贈券活動名稱
                currentPage: 1, // 目前頁碼
                totalRows: 0, // 總筆數
                startRowNum: 0,
                endRowNum: 0
            },
            pageRows: 20, // 一頁幾筆
            API_URL: API_URL,
            //-------票券------------------------start
            listTicket1: [],
            listTicket2: [],
            //-------票券------------------------end
            //------EditTick--------------
            editModalShow: false,
            editId: 0,
            editName: '',
            editToSendMessage: true,
            editGiveType: '',
            editGiveTypeName:'',
            editTicketCode: '',
            editTicketName: '',
            editIsSend: false,
            editSaleDay_S: '',
            editSaleDay_E: '',
            editUpdTime: '',
            editUpdId: '',
            editStoreName: '',
            editAmount: 0,
            editMobile: '',
            memberAmount: 0,
        };
    },
    created () {
      this.FunctionPermission = getFunctionPermission('F31') // 功能權限 帶入功能代碼
      // 分頁處理 : for 第一次進查詢頁 & 從編輯頁跳回來時
        if (this.FunctionPermission > 0) {
            if (this.$route !== undefined) {
                if (this.$route.params.modelTab !== undefined) {
                this.modelTab = this.$route.params.modelTab
                }
                if (this.$route.params.queryTab1 !== undefined) {
                this.queryTab1 = this.$route.params.queryTab1
                }
                if (this.$route.params.queryTab2 !== undefined) {
                this.queryTab2 = this.$route.params.queryTab2
                }
                if (this.$route.params.collapse !== undefined) {
                this.collapse = this.$route.params.collapse
                }
            }
            this.changeTab(this.modelTab)
        } else {
            this.$router.push({ name: 'name' })
        }
    },
    components: {
        draggable
    },
    mounted: function () { },
    props: {
        value: {
            default: undefined
        }
    },
    methods: {
        resetForm1() {
            this.queryTab1.queryGiveType1 = 0, // 查詢條件:贈券型態
            this.queryTab1.queryTciketName1 = '' // 查詢條件:贈券活動名稱
        },
        resetForm2() {
            this.queryTab2.queryGiveType2 = 0, // 查詢條件:贈券型態
            this.queryTab2.queryTciketName2 = '' // 查詢條件:贈券活動名稱
        },
        onSubmit_APP: function () {
            if (this.formstate.$invalid) {
            } else {
                this.openEditAppTypeModal()
            }
        },
        changeTab (tab) {
            this.tab = tab
            if (tab === 1) {
                this.queryTab1.currentPage = 1
            } else if (tab === 2) {
                this.queryTab2.currentPage = 1
            }
            // this.currentPage = 1
            this.query(tab)
        },
        query (tab) {

                var current = 1
                if (tab === 1) {
                    current = this.queryTab1.currentPage
                } else if (tab === 2) {
                    current = this.queryTab2.currentPage
                }

                this.$parent.Loading = true
                this.search(current)
        },
        search: function (currentPage) {

                var giveType = 0
                var name = ''

                if (this.tab == 1) {
                    if (currentPage == 1) {
                        this.queryTab1.currentPage = currentPage
                    }
                    giveType = Number(this.queryTab1.queryGiveType1)
                    name = this.queryTab1.queryTciketName1
                } else if (this.tab == 2) {
                    if (currentPage == 1) {
                        this.queryTab2.currentPage = currentPage
                    }
                    giveType = Number(this.queryTab2.queryGiveType2)
                    name = this.queryTab2.queryTciketName2
                }
                this.$parent.Loading = true
                return axios.post(API_URL + '/web/ticketGive/query', {
                    toPage: currentPage,
                    perPage: this.pageRows,
                    name: name, // 票券名稱
                    giveType: giveType, // 贈卷型態 (1:新加入會員, 2:生日禮,3:所有會員)
                    status: Number(this.tab) // 1:進行中 2:過期
                })
                    .then((response) => {
                        this.$parent.Loading = false
                        if (response.data.result === '0000') {
                            if (this.tab === 1) {
                                this.queryTab1.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
                                this.listTicket1 = response.data.data
                                this.queryTab1.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.queryTab1.currentPage - 1) + 1
                                this.queryTab1.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.queryTab1.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.queryTab1.currentPage * this.pageRows
                            } else if (this.tab === 2) {
                                this.listTicket2 = response.data.data
                                this.queryTab2.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
                                this.queryTab2.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.queryTab2.currentPage - 1) + 1
                                this.queryTab2.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.queryTab2.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.queryTab2.currentPage * this.pageRows
                            }
                        } else {
                            if (response.data.result === '0006') {
                                this.$parent.logOut(false, true)
                            } else {
                                miniToastr.error(response.data.message, '錯誤訊息')
                            }
                        }
                        this.$parent.Loading = false
                    })
                    .catch((error) => {
                        miniToastr.error(error, '錯誤訊息')
                        this.$parent.Loading = false
                    })
        },
        nowDate: function () {
            var time = new Date();
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var day = time.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        },
        editTicket (item) {
            this.editId = item.id
            this.editName = item.name;
            this.editToSendMessage = item.toSendMessage;
            this.editGiveType = item.giveType;
            this.editGiveTypeName = item.giveTypeName;
            this.editTicketCode = item.giftCertificateCode;
            this.editTicketName = item.giftCertificateName;
            this.editSaleDay_S = item.applicableStartAt.replace(/\//g, '-');
            this.editSaleDay_E = item.applicableEndAt.replace(/\//g, '-');
            this.editIsSend = item.isSend;
            this.editAmount = item.amount;
            this.editUpdId = item.updatedName;
            this.editStoreName = item.storeName;
            this.editUpdTime = item.updatedAt;
            this.editMobile = item.mobile;
            this.memberAmount = item.memberAmount;
            this.$refs.editTicket.show();
        },
        editCancel () {
            this.$refs.editTicket.hide();
        },
    },
    computed: {
        // 排序參數設定
        dragOptions () {
            return {
                disabled: this.sort_disabled,
            }
        },
    }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 220px;
  height: 140px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 35%;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/give/List.vue